import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import UpdateEmail from "./updateEmail";
import UpdatePassword from "./updatePassword";
import VerificationStatus from "./verificationStatus";

const Setting = ({ setUserEmail, role }) => {
    const [emailTxt, setEmailTxt] = useState("");

    useEffect(() => {
        getEmail();
    }, [])

    const getEmail = () => {
        const email = localStorage.getItem("email");
        if (!email) return;
        const [username, domain] = email.split('@');
        const visiblePart = username.slice(-4);
        setEmailTxt(`${visiblePart}@${domain}`);
    }

    return (
        <>
            <div className="setting-card-box">
                <div className="card-box-inner">
                    <h5>Personal Information</h5>
                    <div className="row g-4 mb-4">
                        <div className="inner-box-sett">
                            <div className="cus-email-div col-md-6 d-flex align-items-center justify-content-between">
                                <div>
                                    <label className="form-label">Email</label>
                                    <div>•••• {emailTxt}</div>
                                </div>
                                <button className="btn-edit" data-bs-toggle="modal" data-bs-target="#emailModal">Edit</button>
                            </div>
                            <div className="cus-pass-div col-md-6 d-flex align-items-center justify-content-between">
                                <div>
                                    <label className="form-label">Password</label>
                                    <div>••••••••</div>
                                </div>
                                <button className="btn-edit" data-bs-toggle="modal" data-bs-target="#passwordModal">Edit</button>
                            </div>
                        </div>
                    </div>

                    {role === "user" &&
                        <VerificationStatus />
                    }
                </div>
            </div>

            <UpdateEmail setEmailTxt={setEmailTxt} setUserEmail={setUserEmail} />
            <UpdatePassword />
        </>
    );
};

export default Setting;
